<template>
  <div class="shopping-cart-table">
    <el-table
      :data="list"
      style="width: 100%"
      @selection-change="handleSelectionChange"
      ref="tableRef"
      class="custom-table"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" width="55" align="center"></el-table-column>

      <el-table-column prop="name" label="商品信息" min-width="320">
        <template slot-scope="scope">
          <div class="product-info">
            <div class="relative">
              <div class="isLost" v-if="scope.row.lostEffectiveness">已失效</div>
              <img
                class="product-img cursor-pointer"
                @click.stop="productsDetails(scope.row.goods)"
                :src="getImgUrl(scope.row.goods.images)"
                alt=""
              />
            </div>
            <div class="product-content">
              <div class="product-name">
                <span v-if="scope.row.lostEffectiveness">
                  {{ scope.row.name + " " + scope.row.code }}
                </span>
                <el-tooltip v-else class="item" effect="dark" :content="scope.row.goods.subject" placement="top-start">
                  <span class="cursor-pointer" @click.stop="productsDetails(scope.row.goods)">{{
                    scope.row.goods.subject
                  }}</span>
                </el-tooltip>
              </div>
              <template v-if="scope.row.lostEffectiveness">
                <div class="buy-params">
                  <span class="invalid-param">已失效</span>
                </div>
              </template>
              <template v-else>
                <div class="product-tags">
                  <span
                    v-show="scope.row.goods.extaCode"
                    class="tag exchange cursor-pointer"
                    @click="productsDetails(scope.row.goods, true)"
                  >
                    互换
                  </span>
                  <span v-show="scope.row.goods.promotion" class="tag promotion">
                    促销
                  </span>
                  <span v-show="scope.row.goods.limitString" class="tag new">
                    限购
                  </span>
                  <span class="tag coupon" v-for="item in couponList(scope.row.goods.coupons)" :key="item.id">
                    <span class="coupon-icon">券</span>
                    {{ item.title }}
                  </span>
                  <span class="dash">
                    {{ scope.row.goods && scope.row.goods.coupons && scope.row.goods.coupons.length > 2 ? "..." : "" }}
                  </span>
                </div>
                <div class="promotion-text" v-if="scope.row.goods.promotion || scope.row.goods.limitString">
                  {{ scope.row.goods.promotion }} {{ scope.row.goods.limitString }}
                </div>
              </template>
            </div>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="buyParams" label="购买参数" width="120" align="center">
        <template slot-scope="scope">
          <div class="buy-params cursor-pointer" v-if="!scope.row.lostEffectiveness">
            <span
              :class="{ 'invalid-param': scope.row.goodsSpecification.show.includes('失效') }"
              @click.stop="editDetails(scope.row)"
            >
              {{ scope.row.goodsSpecification.show }}
            </span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column prop="goods.qty" label="库存" width="100" align="center">
        <template slot-scope="scope">
          <div class="stock-info" v-if="!scope.row.lostEffectiveness">
            <span :class="{ 'low-stock': scope.row.goods.qty < 10 }">
              {{ scope.row.goods.qty }}
            </span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column prop="price" label="单价" width="180" align="center">
        <template slot-scope="scope">
          <div class="price-info" v-if="!scope.row.lostEffectiveness">
            <div class="price-main">
              <span v-if="scope.row.goods.price" class="price-container">
                <template v-if="scope.row.goods.price.includes('~')">
                  <span class="price-icon">￥</span>
                  <span class="price-integer">{{ scope.row.goods.price.split("~")[0].split(".")[0] }}</span>
                  <span class="price-decimal" v-if="scope.row.goods.price.split('~')[0].split('.').length > 1"
                    >.{{ scope.row.goods.price.split("~")[0].split(".")[1] }}</span
                  >
                  <span v-else class="price-decimal">.00</span>
                  <span class="price-integer"> ~ </span>
                  <span class="price-icon">￥</span>
                  <span class="price-integer">{{ scope.row.goods.price.split("~")[1].split(".")[0] }}</span>
                  <span class="price-decimal" v-if="scope.row.goods.price.split('~')[1].split('.').length > 1"
                    >.{{ scope.row.goods.price.split("~")[1].split(".")[1] }}</span
                  >
                  <span v-else class="price-decimal">.00</span>
                </template>
                <template v-else-if="scope.row.goods.price.includes('起')">
                  <span class="price-icon">￥</span>
                  <span class="price-integer">{{ scope.row.goods.price.split("起")[0].split(".")[0] }}</span>
                  <span class="price-decimal" v-if="scope.row.goods.price.split('起')[0].split('.').length > 1"
                    >.{{ scope.row.goods.price.split("起")[0].split(".")[1] }}</span
                  >
                  <span v-else class="price-decimal">.00</span>
                  <span class="price-integer">起</span>
                </template>
                <template v-else>
                  <span class="price-icon" v-if="!scope.row.goods.price.includes('议价')">￥</span>
                  <span class="price-integer">{{ scope.row.goods.price.split(".")[0] }}</span>
                  <span class="price-decimal" v-if="scope.row.goods.price.split('.').length > 1"
                    >.{{ scope.row.goods.price.split(".")[1] }}</span
                  >
                  <span v-else class="price-decimal">{{ !scope.row.goods.price.includes("议价") ? ".00" : "" }}</span>
                </template>
                <span class="price-unit" v-show="scope.row.goods.unit && !scope.row.goods.price.includes('议价')"
                  >/{{ scope.row.goods.unit }}</span
                >
              </span>
            </div>
            <div v-if="Number(scope.row.goods.linePrice) > 0">
              <span class="original-price"
                >￥{{
                  scope.row.goods.linePrice.split(".").length > 1
                    ? scope.row.goods.linePrice
                    : scope.row.goods.linePrice + ".00"
                }}</span
              >
            </div>
            <div v-if="scope.row.goods.priceGapName">
              <span class="last-price">{{ scope.row.goods.priceGapName }}</span>
            </div>
            <div v-if="Number(scope.row.goods.lastPrice) > 0" class="last-price">
              上次售价：￥{{
                scope.row.goods.lastPrice.split(".").length > 1
                  ? scope.row.goods.lastPrice
                  : scope.row.goods.lastPrice + ".00"
              }}
            </div>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column prop="qty" label="数量" width="150" align="center">
        <template slot-scope="scope">
          <div class="quantity-control" v-if="!scope.row.lostEffectiveness">
            <div class="text-red flex1" v-if="scope.row.goods.minBuyQty > 1">
              起订量：{{ scope.row.goods.minBuyQty }}
            </div>
            <ControlInput
              :model-value="scope.row.qty"
              @change="n => changeQty(scope.$index, n)"
              @crearValue="n => changeQty(scope.$index, n)"
              :min="0"
              :min-value="Number(scope.row.goods.minQty)"
              :step="Number(scope.row.goods.uQty)"
              :disabled="
                scope.row.goodsSpecification.show.includes('失效') ||
                  scope.row.lostEffectiveness ||
                  scope.row.outOfStock
              "
              :max="scope.row.goods.qty"
            ></ControlInput>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column prop="total" label="小计" width="120" align="center">
        <template slot-scope="scope">
          <div class="subtotal" v-if="!scope.row.lostEffectiveness">
            <span class="subtotal-price">￥{{ (scope.row.qty * scope.row.goods.price).toFixed(2) }}</span>
          </div>
          <div v-else>-</div>
        </template>
      </el-table-column>

      <el-table-column prop="createdByName" label="添加人" width="100" align="center">
        <template slot-scope="scope">
          <div class="creator">
            <span>{{ scope.row.createdByName }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="createdAt" label="添加时间" width="160" align="center">
        <template slot-scope="scope">
          <div class="create-time">
            <span>{{ scope.row.createdAt }}</span>
          </div>
        </template>
      </el-table-column>

      <el-table-column prop="option" label="操作" width="80" align="center" fixed="right">
        <template slot-scope="scope">
          <div class="action-buttons">
            <el-popconfirm
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon="el-icon-warning"
              icon-color="#f56c6c"
              title="确定删除这个商品吗？"
              @confirm="deleteCartItem(scope.row)"
            >
              <el-button type="danger" size="mini" plain slot="reference" class="delete-btn">
                删除
              </el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <ProductsDetailsBox :isShoppingCart="true" ref="productsDetailsBox" />
  </div>
</template>

<script>
import ControlInput from "../products/components/ControlInput.vue";
import { deleteShoppingCart } from "@/api/shoppingCart/index.js";
import { editShoppingCart } from "@/api/shoppingCart/index.js";
import { mapState } from "vuex";
import { getGoodsName } from "@/views/newProducts/minin/homepage.js";
import ProductsDetailsBox from "@/components/ProductsDetailsBox";
export default {
  components: {
    ControlInput,
    ProductsDetailsBox
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    selectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      multipleSelection: []
    };
  },
  computed: {
    ...mapState("goods", {
      goodNameRules: state => {
        return state.goodNameRules;
      }
    })
  },
  methods: {
    productsDetails(item, showExchange) {
      if (showExchange) {
        item.showExchange = true;
      }
      this.$router.push({
        path: "/new-products/product-details",
        query: {
          data: encodeURIComponent(JSON.stringify(item))
        }
      });
    },
    // 检查商品是否可以被选择
    checkSelectable(row, index) {
      // 不可选择的条件：
      // 1. 缺货
      // 2. 已失效
      // 3. 购买规格已失效
      return !(row.outOfStock || row.lostEffectiveness || row.goodsSpecification.show.includes("失效"));
    },
    //弹出多规格购买弹框
    editDetails(row) {
      const goodsItem = Object.assign(row.goods, {
        goodsNum: row.qty,
        carts_id: row.id,
        goodsSpecification: row.goodsSpecification
      });
      this.$refs.productsDetailsBox.show(goodsItem);
    },
    tableRowClassName({ row }) {
      if (row.outOfStock || row.lostEffectiveness || row.goodsSpecification.show.includes("失效")) {
        return "disabled-row";
      }
      return "";
    },
    selectAllFun() {
      if (this.$refs.tableRef) {
        this.$refs.tableRef.toggleAllSelection();
      }
    },
    handleSelectionChange(val) {
      if (val.length !== this.list.length) {
        this.$emit("cancelSelectAll");
      }
      this.multipleSelection = val;
      this.$emit("changeSelect", val);
    },
    couponList(list) {
      if (list && list.length > 2) {
        return list.slice(0, 2);
      }
      if (list && list.length <= 2) {
        return list;
      }
      return [];
    },
    getImgUrl(imgList) {
      if (imgList && imgList.length > 0) {
        return imgList[0];
      }
      return require("@/assets/img/no-goods-img.png");
    },

    getGoodName(item) {
      return getGoodsName(this.goodNameRules, item);
    },
    changeQty(index, n) {
      const item = this.list[index];
      if (n == 0) {
        this.$confirm("确定删除这个商品吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            this.deleteCartItem(item);
            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除"
            });
          });
        return;
      }

      item.cartQty = n;
      this.addShoppingCartFun(item, n);
    },
    async addShoppingCartFun(item, n) {
      try {
        await editShoppingCart({ id: item.id, qty: n });
        this.$message.success("修改成功");
        await this.$bus.$emit("shoppingCartRefresh");
        await this.$emit("refresh");
      } catch (error) {
        this.$message.error(`操作失败，${error.message}`);
      }
    },
    async deleteCartItem(row) {
      try {
        await deleteShoppingCart({ ids: [row.id] });
        this.$message.success("删除成功");
        this.$bus.$emit("shoppingCartRefresh");
        this.$emit("refresh");
      } catch (error) {
        this.$message.error("删除失败," + error.message);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.dash {
  font-size: 16px;
  color: #333;
}
.shopping-cart-table {
  .custom-table {
    // border-radius: 8px;
    overflow: hidden;
    // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);

    ::v-deep .el-table__header {
      th {
        background: var(--color-primary);
        color: white;
        font-weight: 600;
        border: none;
      }
    }

    ::v-deep .el-table__body {
      tr:hover > td {
        background: #f8f9fa !important;
      }

      .disabled-row {
        td {
          background-color: #fef0f0 !important;
          color: #c0c4cc;
        }

        &:hover > td {
          background-color: #fef0f0 !important;
        }
      }
    }
  }
}
.isLost {
  position: absolute;
  left: 0;
  top: 0;
  display: block;
  width: 60px;
  height: 60px;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 10;
  line-height: 60px;
  text-align: center;
  color: #fff;
}
.product-info {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 8px 0;

  .product-img {
    width: 60px;
    height: 60px;
    border-radius: 2px;
    object-fit: cover;
    border: 1px solid #e4e7ed;
    flex-shrink: 0;
  }

  .product-content {
    flex: 1;
    min-width: 0;

    .product-name {
      font-size: 14px;
      font-weight: 600;
      color: #333;
      line-height: 1.4;
      margin-bottom: 6px;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }

    .product-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 4px;
      margin-bottom: 4px;
    }

    .promotion-text {
      font-size: 12px;
      color: #e84f47;
      font-weight: 500;
    }
  }
}

.buy-params {
  .invalid-param {
    color: #f56c6c;
    font-style: italic;
  }
}

.stock-info {
  .low-stock {
    color: #f56c6c;
    font-weight: 600;
  }
}

.price-info {
  text-align: center;

  .price-main {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    margin-bottom: 2px;
  }
  .price-container {
    display: flex;
    align-items: baseline;

    .price-icon {
      font-size: 14px;
      color: #e84f47;
      font-weight: 600;
    }

    .price-integer {
      font-size: 22px;
      color: #e84f47;
      font-weight: 700;
      margin-left: 2px;
    }

    .price-decimal {
      font-size: 14px;
      color: #e84f47;
      font-weight: 600;
    }

    .price-unit {
      color: #999;
      font-weight: 400;
      font-size: 12px;
      margin-left: 4px;
    }
  }
  .current-price {
    font-size: 16px;
    font-weight: 700;
    color: #e84f47;
  }

  .original-price {
    font-size: 12px;
    color: #999;
    text-decoration: line-through;
  }

  .last-price {
    font-size: 11px;
    color: #e84f47;
    font-weight: 500;
  }
}

.quantity-control {
  display: flex;
  justify-content: center;
  flex-direction: column;
  row-gap: 8px;
}

.subtotal {
  .subtotal-price {
    font-size: 14px;
    font-weight: 700;
    color: #e84f47;
  }
}

.creator,
.create-time {
  color: #666;
  font-size: 13px;
}

.action-buttons {
  .delete-btn {
    font-size: 12px;
    padding: 5px 10px;
    border-radius: 2px;
    transition: all 0.3s;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 4px rgba(245, 108, 108, 0.3);
    }
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .product-info {
    .product-img {
      width: 50px;
      height: 50px;
    }

    .product-content {
      .product-name {
        font-size: 13px;
      }
    }
  }
}

@media (max-width: 768px) {
  .shopping-cart-table {
    .custom-table {
      ::v-deep .el-table__body-wrapper {
        overflow-x: auto;
      }
    }
  }

  .product-info {
    flex-direction: column;
    align-items: center;
    text-align: center;

    .product-content {
      .product-tags {
        justify-content: center;
      }
    }
  }
}
</style>
